module.exports = __webpack_public_path__ + "img/workNewsCover5.89eb663a.png";